import React from 'react';
import { Input } from 'antd';

const CustomInput = ({ state, setState, placeholder, ...props }) => {
  const handleTextChange = (e) => {
    const value = e.target.value;
    setState(value);
  };

  return <Input placeholder={placeholder} value={state} onChange={handleTextChange} {...props} />;
};

export default CustomInput;
